import { render } from "./PlatformInvite.vue.js?vue&type=template&id=04bad422!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PlatformInvite.vue?vue&type=template&id=04bad422"
import script from "./PlatformInvite.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PlatformInvite.vue?vue&type=script&lang=js"
export * from "./PlatformInvite.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PlatformInvite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/PlatformInvite.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04bad422"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04bad422', __exports__)) {
    api.reload('04bad422', __exports__)
  }
  
  module.hot.accept("./PlatformInvite.vue.js?vue&type=template&id=04bad422!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PlatformInvite.vue?vue&type=template&id=04bad422", () => {
    api.rerender('04bad422', render)
  })

}


export default __exports__